import React from "react";
import Discover from "../Dashboard/DiscoverPage";
import ExclusiveDeals from "../Dashboard/ExclusiveDeals";
import Activities from "../Dashboard/Activities";
import PopularVendors from "../Dashboard/PopularVendors";
import StateSection from "../Dashboard/StateSection";
import PopularCategories from "../Dashboard/PopularCategories ";
import CommunitySection from "../Dashboard/CommunitySection";
import HowItWorks from "../Dashboard/HowItWorks";


const Home = () => {
  return (
    <>
      <Discover />
      <StateSection />
      <ExclusiveDeals />
      <PopularCategories />
      <Activities />
      <HowItWorks />
      <PopularVendors />
      <CommunitySection />
    </>
  );
};

export default Home;
